// @flow
import {combineReducers} from 'redux';
import type {BonusesActionType} from './actions';
import type {StateType} from '../reducers';
import type {
  GodchildBonusType,
  GodfatherBonusType,
  ReferralBonuses,
} from 'digicel-kaizen-library';

const initialReferralState: ReferralBonusesStateType = {
  endDateTime: null,
  godchild: null,
  godfather: null,
  isDiscount: false,
};

const initialGodfatherBonusState: GodfatherBonusStateType = {
  count: 0,
  amount: 0,
};

const initialActivationState: ActivationBonusStateType = {
  amount: null,
};

const initialFreeTrialActivationBonusState: FreeTrialActivationBonusStateType =
{
  freeTrial: null,
};

const referralReducer = (
  state: ReferralBonusesStateType = initialReferralState,
  action: BonusesActionType,
) => {
  switch (action.type) {
    case 'SET_REFERRAL_BONUSES':
      return {
        ...state,
        ...action.payload.referralBonuses,
      };
    default:
      return state;
  }
};

const godfatherBonusReducer = (
  state: GodfatherBonusStateType = initialGodfatherBonusState,
  action: BonusesActionType,
) => {
  switch (action.type) {
    case 'SET_GODFATHER_BONUS':
      return {
        ...state,
        ...action.payload.godfatherBonus,
      };
    default:
      return state;
  }
};

const activationReducer = (
  state: ActivationBonusStateType = initialActivationState,
  action: BonusesActionType,
) => {
  switch (action.type) {
    case 'SET_ACTIVATION_BONUS':
      return {
        ...state,
        ...action.payload.activationBonus,
      };
    default:
      return state;
  }
};

const freeTrialActivationBonusReducer = (
  state: FreeTrialActivationBonusStateType = initialFreeTrialActivationBonusState,
  action: BonusesActionType,
) => {
  switch (action.type) {
    case 'SET_FREE_TRIAL_ACTIVATION_BONUS':
      return {
        ...state,
        freeTrial: action.payload.freeTrial,
      };
    default:
      return state;
  }
};

export default combineReducers({
  referral: referralReducer,
  activation: activationReducer,
  freeTrial: freeTrialActivationBonusReducer,
  godFatherBonus: godfatherBonusReducer,
});

const bonusesStateSelector = (state: StateType): BonusesStateType =>
  state.bonuses;

const referralBonusesStateSelector = (
  state: StateType,
): ReferralBonusesStateType => {
  const bonusesState = bonusesStateSelector(state);
  return bonusesState.referral;
};

const activationBonusStateSelector = (
  state: StateType,
): ActivationBonusStateType => {
  const bonusesState = bonusesStateSelector(state);
  return bonusesState.activation;
};

export const freeTrialActivationBonusStateSelector = (
  state: StateType,
): FreeTrialActivationBonusStateType => {  
  const bonusesState = bonusesStateSelector(state);
  return bonusesState.freeTrial;
};

export const referralBonusesSelector = (state: StateType): ?ReferralBonuses => {
  const referralBonusesState = referralBonusesStateSelector(state);
  const {endDateTime, godchild, godfather, isDiscount} = referralBonusesState;
  if (godchild == null || godfather == null) return null;
  return {
    endDateTime,
    godchild,
    godfather,
    isDiscount,
  };
};

export const activationBonusAmountSelector = (state: StateType): ?number => {
  const activationBonusState = activationBonusStateSelector(state);
  return activationBonusState.amount;
};

export const isDiscountSelector = (state: StateType): boolean => {
  const referralBonusesState = referralBonusesStateSelector(state);
  const {isDiscount} = referralBonusesState;
  return isDiscount;
};

export type ReferralBonusesStateType = {
  endDateTime: ?number,
  godchild: ?GodchildBonusType,
  godfather: ?GodfatherBonusType,
  isDiscount: boolean,
};

export type GodfatherBonusStateType = {
  count: number,
  amount: number,
};

export type ActivationBonusStateType = {
  amount: ?number,
};

export type FreeTrialActivationBonusStateType = {
  value: ?Object,
};

export type BonusesStateType = {
  referral: ReferralBonusesStateType,
  activation: ActivationBonusStateType,
};
